type CarouselProps = {
  slideSelector: string
  activeSlideSelector: string
  nextSlideSelector: string
  prevSlideSelector: string
}

export default function testimonialCarousel(
  el: HTMLElement,
  props: CarouselProps
) {
  const totalSlides: number = el.querySelectorAll(props.slideSelector).length
  const allSlidesNodes: NodeListOf<HTMLElement> = el.querySelectorAll(
    props.slideSelector
  )
  const firstActiveSlide: HTMLElement | null = el.querySelector(
    props.activeSlideSelector
  )
  const nextButton: HTMLButtonElement | null = el.querySelector(
    props.nextSlideSelector
  )
  const prevButton: HTMLButtonElement | null = el.querySelector(
    props.prevSlideSelector
  )
  const slideCounter: HTMLElement | null = el.querySelector(
    ".testimonial-slide-counter"
  )
  const slideTotal: HTMLElement | null = el.querySelector(
    ".testimonial-slide-total"
  )

  const ulEl = el.querySelector("ul")

  const bodyEl = document.querySelector("body")

  if (
    totalSlides == null ||
    firstActiveSlide == null ||
    allSlidesNodes == null ||
    nextButton == null ||
    prevButton == null
  ) {
    return
  }

  function setDefaultSlides() {
    // set position relative in UL
    if (ulEl !== null && !ulEl.classList.contains("relative")) {
      ulEl.classList.add("relative")
    }
    // by default slides are in the DOM
    allSlidesNodes.forEach((slide, index) => {
      // Hide all non active slides
      if (!slide.classList.contains("slide-item--active")) {
        slide.classList.add("invisible")
        slide.classList.add("inset-0")
      } else {
        slide.setAttribute("aria-selected", "true")
      }

      if (slideTotal) {
        slideTotal.innerHTML = `${allSlidesNodes.length}`
      }
      if (slideCounter) {
        slideCounter.innerHTML = `${1}`
      }
      // Create span with testimonial counter for screen readers only
      const screenReaderOnly = document.createElement("span")
      screenReaderOnly.classList.add("sr-only")
      screenReaderOnly.textContent = `Testimonial slide ${index + 1} of ${
        allSlidesNodes.length
      }`
      slide.prepend(screenReaderOnly)
    })
  }

  let currentSlide = 0

  function displaySlide(index: number) {
    // Hide old slide
    allSlidesNodes[currentSlide]?.classList.remove(
      "slide-item--active",
      "motion-safe:animate-slide-fade-in"
    )
    if (
      !allSlidesNodes[currentSlide]?.classList.contains("slide-item--active")
    ) {
      allSlidesNodes[currentSlide]?.classList.add("invisible", "inset-0")
      allSlidesNodes[currentSlide]?.setAttribute("aria-selected", "false")
      allSlidesNodes[currentSlide]?.setAttribute("tabindex", "-1")
    }
    // Display new current slide
    allSlidesNodes[index]?.classList.add("slide-item--active")
    if (allSlidesNodes[index]?.classList.contains("slide-item--active")) {
      allSlidesNodes[index]?.classList.remove("invisible", "inset-0")
      allSlidesNodes[index]?.classList.add("motion-safe:animate-slide-fade-in")
      allSlidesNodes[index]?.setAttribute("aria-selected", "true")
      allSlidesNodes[index]?.setAttribute("tabindex", "0")
    }
    // Slide counter active indicator
    // setActiveSlideIndicator(index)
    currentSlide = index

    if (slideCounter) {
      slideCounter.innerHTML = `${currentSlide + 1}`
    }
  }

  function nextSlide() {
    let nextSlide

    if (currentSlide < totalSlides - 1) {
      nextSlide = currentSlide + 1
    } else {
      nextSlide = 0
    }

    displaySlide(nextSlide)
  }

  function previousSlide() {
    let previousSlide
    if (currentSlide <= 0) {
      previousSlide = totalSlides - 1
    } else {
      previousSlide = currentSlide - 1
    }
    displaySlide(previousSlide)
  }

  let xDown: number = 0
  let yDown: number = 0

  function getTouches(evt: TouchEvent) {
    return evt.touches
  }

  function handleTouchStart(evt: TouchEvent) {
    const firstTouch = getTouches(evt)[0]
    xDown = firstTouch?.clientX ?? 0
    yDown = firstTouch?.clientY ?? 0
  }

  function handleTouchMove(evt: TouchEvent) {
    if (!xDown || !yDown) {
      return
    }

    const xUp = evt.touches[0]?.clientX ?? 0
    const yUp = evt.touches[0]?.clientY ?? 0

    const xDiff = xDown - xUp
    const yDiff = yDown - yUp

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      // swipe right to left
      if (xDiff > 0) {
        nextSlide()
        // block vertical scroll on swiping
        bodyEl?.classList.add("overflow-y-hidden")
      } else {
        // swipe left to right
        previousSlide()
        // block vertical scroll on swiping
        bodyEl?.classList.add("overflow-y-hidden")
      }
    }
    /* reset values */
    xDown = 0
    yDown = 0
    bodyEl?.classList.remove("overflow-y-hidden")
  }

  function handleKeyboardFocus(event: KeyboardEvent, fn: () => void) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault()
      fn()
      const activeSlide: HTMLElement | null = el.querySelector(
        ".slide-item--active"
      )
      activeSlide?.focus()
    }
  }

  // Add event listener to bind nextSlide function on NextButton
  nextButton.addEventListener("click", function (event) {
    event.preventDefault()
    nextSlide()
  })

  nextButton.addEventListener("keydown", event => {
    handleKeyboardFocus(event, nextSlide)
  })

  // Add event listener to bind previousSlide function on PrevButton
  prevButton.addEventListener("click", function (event) {
    event.preventDefault()
    previousSlide()
  })

  prevButton.addEventListener("keydown", event => {
    handleKeyboardFocus(event, previousSlide)
  })

  el.addEventListener("touchstart", handleTouchStart)

  el.addEventListener("touchmove", handleTouchMove, false)

  function loadSlides() {
    el.classList.remove("invisible")
    setDefaultSlides()
  }

  if (document.readyState === "loading") {
    window.addEventListener("load", loadSlides)
  } else {
    loadSlides()
  }
}
